










import Component, { mixins } from 'vue-class-component';
import { VModel } from 'vue-property-decorator';
import Form from '@/general/abstract/form/mixin/Form';
import { IdResponse } from '@/common/model/IdResponse';
import { SensorFormModel } from '@/context/sensor/model/SensorFormModel';
import FormBase from '@/general/abstract/form/FormBase.vue';
import SensorForm from '@/context/sensor/component/form/SensorForm.vue';
import { sensorApi } from '@/context/sensor/api/SensorApi';
import { sensorRouter } from '@/context/sensor/router/SensorRouter';

@Component({
  components: {
    SensorForm,
    FormBase
  }
})
export default class SensorUpdateContainer extends mixins<
  Form<SensorFormModel, SensorFormModel, IdResponse>
>(Form) {
  @VModel({ default: new SensorFormModel() }) model!: SensorFormModel;

  buildCmd(): SensorFormModel {
    return this.model;
  }

  async submitApi(cmd: SensorFormModel): Promise<IdResponse> {
    const result: IdResponse = await sensorApi.update<SensorFormModel, IdResponse>(cmd);
    console.log(result);
    return result;
  }

  showRoute(id: number): Record<string, unknown> {
    return sensorRouter.show(id);
  }
}
